export function startDownloadInBrowser(
  url: string | undefined,
  fileName: string,
) {
  if (url) {
    const aDnd = document.createElement("a");
    aDnd.download = fileName;
    aDnd.href = url;
    aDnd.click();
  }
}
